import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const VideoSlider = ({ projects }) => {
    const [swiperInstance, setSwiperInstance] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    if (!projects?.videos?.data?.length) return <p>No videos available</p>;

    const handlePrev = () => swiperInstance?.slidePrev();
    const handleNext = () => swiperInstance?.slideNext();

    return (
        // <div className="h-full max-w-[800px] flex justify-center items-center">
        <div className="relative w-full flex justify-center items-center px-4">
            <button
                onClick={handlePrev}
                className="absolute left-0 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
                disabled={activeIndex === 0}
            >
                <CaretLeft size={20} />
            </button>

            <button
                onClick={handleNext}
                className="absolute right-0 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
                disabled={activeIndex === projects.videos.data.length - 1}
            >
                <CaretRight size={20} />
            </button>
            <Swiper
                // modules={[Navigation, Pagination]}
                spaceBetween={10}
                slidesPerView={1}
                // navigation
                onSwiper={setSwiperInstance}
                onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                // pagination={{ clickable: true }}
                // className="max-w-[800px] h-full flex items-center justify-center"
                className="w-full max-w-[1000px]"
            >
                {projects.videos.data.map((video) => (
                    <SwiperSlide key={video.id} className="flex justify-center items-center">
                        {/* <div className=" h-[400px] max-w-[800px] rounded-lg overflow-hidden"> */}
                        <div className="w-full aspect-[16/9] rounded-lg overflow-hidden">
                            {video.attributes.url.endsWith(".mp4") ? (
                                <video
                                    src={video.attributes.url}
                                    controls
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <img
                                    src={video.attributes.url}
                                    alt={video.attributes.alternativeText || "Thumbnail"}
                                    className="w-full h-full object-cover"
                                />
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default VideoSlider;
